import { render, staticRenderFns } from "./DestinationEditor.vue?vue&type=template&id=6cfa2564"
import script from "./DestinationEditor.vue?vue&type=script&lang=js"
export * from "./DestinationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports